import React, { useState, useEffect,useCallback,useMemo } from "react";
import { InputAdornment } from "@mui/material";
import SideMenu from "../../Components/SideMenu";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";

import OutlinedInput from "@mui/material/OutlinedInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useGlobalContext } from "../../../../../context";
import "../../Dashboard.css";
import Styles from "../../../../Slices/Mof/Styles.json";
import "../../Dashboard.css";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
// import Chip from "@mui/material/Chip";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Cookies from "universal-cookie";
import { ItemDragging } from "devextreme-react/list";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import swal from 'sweetalert';
import SourceOfIncome from "./Components/SourceOfIncome";
import SummationOfIncomeResources from "./Components/SummationOfIncomeResources";
import Discounts from "./Components/Discounts";
import Permitted from "./Components/Permitted";
import TaxableIncome from "./Components/TaxableIncome";
import Fines from "./Components/Fines";
import Interest from "./Components/Interest";
import PaymentsInfo from "./Components/PaymentsInfo";
import CommentOfEstimators from "./Components/CommentOfEstimators";
import CommentsOfChecker from "./Components/CommentsOfChecker";
import CommentOfBranchManger from "./Components/CommentOfBranchManger";
// Import css files
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get("id");
const cookies = new Cookies();

// console.log("myParam", myParam);
export default function IncomeEstimateForm(props) {
  const [inactive, setInactive] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const [snackBar2, setsnackBar2] = useState({
    open: false,
    vertical: "center",
    horizontal: "center",
    message: [],
    severity: "warning",
  });
  const [IPaddress, setIPaddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const [userRole, setUserRole] = useState(cookies.get("role_id"));
  const [userName, setUserName] = useState(cookies.get("userName"));
  const [selecetedAmount, setSelecetedAmount] = useState(0);

  const [user, setUser] = useState({});
  // income resource with values  hooks here...
  const [incomeResourceValuesArrOBJ, setIncomeResourceValuesArrOBJ] = useState(
    []
  );
  const [selectedIncomeResourceValue, setSelectedIncomeResourceValue] =
    useState(null);
  const [listOFIncomeResourceValue, setListOFIncomeResourceValue] = useState(
    []
  );
  const [summationOfAllResources, setSummationOfAllResources] = useState(0);

  // discount ....
  const [discountValuesArrOBJ, setDiscountValuesArrOBJ] = useState([]);
  const [selectedDiscountValuesArrOBJ, setSelectedDiscountValuesArrOBJ] =
    useState(null);
  const [listOFDiscountValuesArrOBJ, setListOFDiscountValuesArrOBJ] = useState(
    []
  );

  // taxable income ...
  const [taxableIncome, setTaxableIncom] = useState(0);
  const [taxableAmount, setTaxableAmount] = useState(null);

  // fines ....
  const [finesValuesArrOBj, setFinesValuesArrOBj] = useState([]);
  const [selectedFinesValuesArrOBj, setSelectedFinesValuesArrOBj] =
    useState(null);
  const [listOFFinesValuesArrOBJ, setListOFFinesValuesArrOBJ] = useState([]);

  // interests ....
  const [interestedValuesArrOBj, setInterestedValuesArrOBj] = useState([]);
  const [selectedInterestedValuesArrOBj, setSelectedInterestedValuesArrOBj] =
    useState(null);
  const [listOFInterestedValuesArrOBj, setListOFInterestedValuesArrOBj] =
    useState([]);

  //payments
  const [voucherNumber, setVoucherNumber] = useState("");
  const [voucherDate, setVoucherDate] = useState(new Date());
  const [ownerDecision, setOwnerDesision] = useState(cookies.get('role_id')==4?false:null);
  const [ownerDecisionDate, setOwnerDecisionDate] = useState(new Date());

  //other hooks
  const [taxAssessor, setTaxAssessor] = useState("");
  const [taxAssessorComments, setTaxAssessorComments] = useState("");

  const [checkerName, setCheckerName] = useState("");
  const [checkerNameComments, setCheckerNameComments] = useState("");

  const [branchManager, setBranchManager] = useState("");
  const [branchManagerComments, setBranchManagerComments] = useState("");
  const [FinalCalculation, setFinalCalculation] = useState({});
  const [disableIncome, setDisableIncome] = useState(false);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [ModeOfInsertData, setModeOfInsertData] = useState("أضافة");
  const [ModeOfInsertData_tow, setModeOfInsertData_tow] = useState("حساب");
  
  const {
    // loading,
    incomeResourceValues,
    interestReasonValues,
    fineReasonValues,
    discountReasonValues,
    permitReasonValues,
    User,
    fetchData,
    setUserInfo,
  } = useGlobalContext();

  useEffect(() => {
    fetchData("INCOME_RESOURCE_VALUES", "income_resource_values_list", {});
    fetchData("INTEREST_REASON_VALUES", "interest_reason_values_list", {});
    fetchData("FINE_REASON_VALUES", "fine_reason_values_list", {});
    fetchData("DISCOUNT_REASON_VALUES", "discount_reason_values_list", {});
    fetchData("PERMIT_REASON_VALUES", "permit_reason_values_list", {});
    setIPaddress(ApiSetting.apiUrl);
    getSelectedAmountForIncomeResource_classess()
    setTimeout(()=>{
      getSelectedAmountForIncomeResource()
      getRepordEstimateInfo(ApiSetting.apiUrl);
    },200)
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
     getCalculationsForAmount(1);

    setUserRole(cookies.get("role_id"));
    setUserName(cookies.get("userName"));
    console.log(cookies.get("role_id"));
    // if (cookies.get("role_id") == 1) {
    //   setUserInfo({ userName: "branch manager", role_id: 1 });
    //   setBranchManager("branch manager");
    // } else if (cookies.get("role_id") == 2) {
    //   setUserInfo({ userName: "checker", role_id: 2 });
    //   setCheckerName("checker");
    // } else if (cookies.get("role_id") == 3) {
    //   setUserInfo({ userName: "estimator", role_id: 3 });
    //   setTaxAssessor("tax payer");
    // } else if (cookies.get("role_id") == 4) {
    //   setUserInfo({ userName: "tax payer", role_id: 4 });
    // }
  }, []);
  console.log(User);
  useEffect(() => {
    if (incomeResourceValues.length > 0) {
      setIncomeResourceValuesArrOBJ([
        ...incomeResourceValues,
        { id: incomeResourceValues.length + 1, resource: "other" },
      ]);
    }
  }, [incomeResourceValues]);

  useEffect(() => {
    if (discountReasonValues.length > 0) {
      setDiscountValuesArrOBJ([
        ...discountReasonValues,
        { id: discountReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [discountReasonValues]);

  useEffect(() => {
    if (fineReasonValues.length > 0) {
      setFinesValuesArrOBj([
        ...fineReasonValues,
        { id: fineReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [fineReasonValues]);

  useEffect(() => {
    if (interestReasonValues.length > 0) {
      setInterestedValuesArrOBj([
        ...interestReasonValues,
        { id: interestReasonValues.length + 1, reason: "other" },
      ]);
    }
  }, [interestReasonValues]);

  useEffect(() => {
    summationOfAllResourcesFunction_update();
  }, [
    listOFDiscountValuesArrOBJ,
    listOFFinesValuesArrOBJ,
    listOFIncomeResourceValue,
    listOFInterestedValuesArrOBj,
  ]);

  //get seleceted amount for income resources.
  const getSelectedAmountForIncomeResource = async () => {
    let data = [];
    try {
      data = await axios({
        method: "post",
        url: ApiSetting.apiUrl+ "/income_estimate_form/calculateAmount",
        data: {
          income_tax_report_id: props?.object?.id,
          // income_resource_value:''
        },
        headers: {
          "Content-Type": "applications/json",
          Accept: "applications/json",
        },
      });
      if (data) {
        if (data.data.status == 200) {
          if (data.data.data?.amount > 0) {
            setListOFIncomeResourceValue((itm)=>[...itm,{
              index: 1,
              resource: "نتيجة الحاسبة (تصاريح وحاسبة)",
              other_resource_value: '',
              amount: data.data.data?.amount,
              comments: data.data.data?.notes,
            }])
            setSelecetedAmount(data.data.data.total_amount);
            // let arr = [];
            // if (selecetedAmount.length > 0) {
            //   let chk = 0;
            //   selecetedAmount.map((itm) => {
            //     if (itm.index == values.index) {
            //       chk = 1;
            //       arr.push({ index: values.index, totlAmount: data.data.data });
            //     } else {
            //       arr.push(itm);
            //     }
            //   });
            //   if (chk == 0) {
            //     arr.push({ index: values.index, totlAmount: data.data.data });
            //   }
            //   setSelecetedAmount(arr);
            // } else {
            //   setSelecetedAmount((itm) => [
            //     ...itm,
            //     { index: values.index, totlAmount: data.data.data },
            //   ]);
            // }
            // setAmountForIncomeResource(values, data.data.data);
          }else{
            setListOFIncomeResourceValue((itm)=>[...itm,{
              index: 1,
              resource: "نتيجة الحاسبة (تصاريح وحاسبة)",
              other_resource_value: '',
              amount: 0,
              comments: '',
              hint:'لم يتم اضافة اي مقتبسات لهذا التقرير'
            }])
          }
        }else if(data.data.status==505){
            
        }  else {
          
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
    }
  };

  const getSelectedAmountForIncomeResource_classess = async () => {
    let data = [];
    // setLoading1(true);
   
      try {
        data = await axios({
          method: "post",
          url:
            ApiSetting.apiUrl + "/income_estimate_form/getIncomeEstimateClass",
          data: {
            income_tax_report_id: props?.object?.id,
            income_resource_value: 'نتيجة اللجنة الفاحصة',
          },
          headers: {
            "Content-Type": "applications/json",
            Accept: "applications/json",
          },
        });
        if (data) {
          if (data.data.status == 200) {
            if (data.data.data && data.data.data?.total_amount >= 0) {
              setDisableIncome(data.data.data?.disable);

              setListOFIncomeResourceValue((itm)=>[...itm,{
                index: 0,
                resource: "نتيجة اللجنة الفاحصة",
                other_resource_value: '',
                amount: data.data.data?.total_amount,
                comments: data.data.data?.notes,
              }])
              
                 
                
                setSelecetedAmount( data.data.data.total_amount);
              // let arr = [];
              // if (selecetedAmount.length > 0) {
              //   let chk = 0;
              //   selecetedAmount.map((itm) => {
              //     if (itm.index == values.index) {
              //       chk = 1;
              //       arr.push({
              //         index: values.index,
              //         totlAmount: data.data.data.total_amount,
              //         disabled: data.data.data.disable,
              //       });
              //     } else {
              //       arr.push(itm);
              //     }
              //   });
              //   if (chk == 0) {
              //     arr.push({
              //       index: values.index,
              //       totlAmount: data.data.data.total_amount,
              //       disabled: data.data.data.disable,
              //     });
              //   }
              //   setSelecetedAmount(arr);
              // } else {
              //   setSelecetedAmount((itm) => [
              //     ...itm,
              //     {
              //       index: values.index,
              //       totlAmount: data.data.data.total_amount,
              //       disabled: data.data.data.disable,
              //     },
              //   ]);
              // }
              // if (data.data.data?.total_amount >= 0)
              //   setAmountForIncomeResource(values, data.data.data.total_amount);
            }
            
          }else if(data.data.status==406){
            setListOFIncomeResourceValue((itm)=>[...itm,{
              index: 0,
              resource: "نتيجة اللجنة الفاحصة",
              other_resource_value: '',
              amount: 0,
              comments: '',
              hint:'لم يتم تشكيل لجنة او اسناد صنف لهذا التقرير'
            }])
          }else if(data.data.status==505){

          } else {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message: data.data.message,
            });
          }
        }
        // setLoading1(false);
      } catch (err) {
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "warning",
          message: err.message,
        });
        setLoading1(false);
      }
    
  };
  const getCurresntSelectedTotalValue = (data) => {
    let totalAmount = 0;
    selecetedAmount.map((itm) => {
      if (itm.index == data.index) {
        totalAmount = itm.totlAmount;
      }
    });
    return totalAmount;
  };

  const getDisabledIncomeResource = (data) => {
    if (selecetedAmount.length > 0) {
      selecetedAmount.map((itm) => {
        if (
          itm.index == data.index &&
          data.resource == "نتيجة اللجنة الفاحصة"
        ) {
          return itm.disabled;
        }
      });
    }
  };

  //=====================get calaulation for resources====================================//
  const getCalculationsForAmount = async (numb) => {
    let data = [];
    setLoading1(true);
    if(numb==2)
    setLoading(true)
    try {
      data = await axios({
        method: "post",
        url:
          ApiSetting.apiUrl +
          "/income_estimate_form/getFinalCalculationsForAmount",
        data: {
          income_tax_report_id: props?.object?.id,
        },
        headers: {
          "Content-Type": "applications/json",
          Accept: "applications/json",
        },
      });
      if (data) {
        if (data.data.status == 200) {
          
          setFinalCalculation(data.data.data);
          setFinalTotalAmount(data.data.data?.total_income);

          if (data.data.data?.total_amount_befor_calculat) {
            setSummationOfAllResources(
              data.data.data.total_amount_befor_calculat
            );
          }

          if (data.data.data?.totla_income_required_for_tax) {
            setTaxableIncom(data.data.data.totla_income_required_for_tax);
          }

          if (data.data.data?.tax_amount) {
            setTaxableAmount(data.data.data.tax_amount);
          }

          setsnackBar({
            ...snackBar,
            open: true,
            severity: "success",
            message: data.data.message,
          });
        }else if( (cookies.get('role_id')!=3 && cookies.get('role_id')!=0 ) ) {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
        if(numb==2){
        setModeOfInsertData_tow('تم الحساب')
        setLoading(false)

        }
      }
      setLoading1(false);
    } catch (err) {
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "warning",
        message: err.message,
      });
      if(numb==2){
      setModeOfInsertData_tow('تم الحساب')
       setLoading(false)
      }
      setLoading1(false);
    }
  };
  //======================================================================================//

  //get data if exists for report id that  sent.
  const getRepordEstimateInfo = async (ipaddress) => {
    let data = null;
    try {
      data = await axios({
        method: "post",
        url: ipaddress + "/income_estimate_form/getinfoOfSelectedReport",
        data: {
          income_tax_report_id: props?.object?.id,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      if (data) {
        if (data.data.status == 200 ) {
          formatDataFromRquet(data.data.data);
        }else if(data.data.status==407){

        } else if((cookies.get('role_id')!=3 && cookies.get('role_id')!=0 ) ) {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "warning",
            message: data.data.message,
          });
        }
      }
    } catch (err) {
      setsnackBar({
        ...snackBar,
        open: true,
        severity: "error",
        message: err.message,
      });
    }
  };

  const formatDataFromRquet = (data) => {
    if (data) {
      setSummationOfAllResources(data.income_estimators_report?.total_income);
      setTaxableIncom(data.income_estimators_report?.total_income_requires_tax);
      setTaxableAmount(data.income_estimators_report?.tax_amount);
      setVoucherNumber(data.income_estimators_report?.receipt_number);
      setVoucherDate(data.income_estimators_report?.receipt_date);
      // setTaxAssessor(data.)
      setTaxAssessorComments(data.income_estimators_report?.estimator_note);
      setCheckerNameComments(data.income_estimators_report?.checker_note);
      setBranchManagerComments(
        data.income_estimators_report?.branch_admin_note
      );

      if(data.incomeResources)
      setListOFIncomeResourceValue((itm)=>[...itm,...data.incomeResources]);
      // if (data?.incomeResources.length > 0) {
      //   data.incomeResources.map((itm) => {
      //     getSelectedAmountForIncomeResource_classess(itm);
      //   });
      // }

      setListOFDiscountValuesArrOBJ(
        data.discountReason ? data.discountReason : []
      );
      setListOFFinesValuesArrOBJ(data.finesReason ? data.finesReason : []);
      setListOFInterestedValuesArrOBj(data.interests ? data.interests : []);
      setVoucherNumber(data?.income_estimators_report?.receipt_number);
      setVoucherDate(new Date(data?.income_estimators_report?.receipt_date));
      setFinalTotalAmount(data?.income_estimators_report?.final_total_amount);
      // setFina
      if (data?.income_estimators_report?.owner_decision == 1)
        setOwnerDesision(true);
      else if(data?.income_estimators_report?.owner_decision == 0) setOwnerDesision(false);

      setOwnerDecisionDate(
        new Date(data?.income_estimators_report?.owner_decision_date)
      );
      setModeOfInsertData("تحديث");
    } else if (!data) {
      setModeOfInsertData("أضافة");
    }
  };

  // ====================store data================================
  const storeDataOfForm = async () => {
    let data = null;
    let ar=[];
    if(listOFIncomeResourceValue.length>0){
      listOFIncomeResourceValue.map(data=>{
        if(data.resource=='other'){
         ar.push(data)
        }
      })
    }


    let formData = {
      list_of_income_resource_values:(ownerDecision==false || ownerDecision==true?listOFIncomeResourceValue:ar), //
      summation_of_all_resources: summationOfAllResources, //....
      list_of_discount_values: listOFDiscountValuesArrOBJ, //
      taxable_income: taxableIncome, //....
      taxable_amount: taxableAmount, //....
      list_of_fines_values: listOFFinesValuesArrOBJ, //
      list_of_interested_values: listOFInterestedValuesArrOBj, //
      voucher_number: voucherNumber, //....
      voucher_date: userRole == 4 ? formatDate(voucherDate) : null, //....
      tax_assessor: taxAssessor, //....
      tax_assessor_comments: taxAssessorComments, //....
      checker_name: checkerName, //....
      checker_name_comments: checkerNameComments, //....
      branch_manager: branchManager, //....
      branch_manager_comments: branchManagerComments, //....
      role_id: userRole, //...
      income_tax_report_id: props?.object?.id, //....
      owner_decision: ownerDecision,
      owner_decision_date: formatDate(ownerDecisionDate),
    };

    if(cookies.get('role_id')==4){
      swal({
        title: "هل انتة موافق?",
        text: "بمجرد عمل تحديث للبيانات لن تستطيع عمل تعديل لها مجددا!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then(async(willDelete) => {
        if (willDelete) {
        setLoading(true);
        try {
          data = await axios({
            method: "post",
            url: IPaddress + "/income_estimate_form/store",
            data: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });
          if (data) {
            if (data.data.status == 200) {
              setsnackBar({
                ...snackBar,
                open: true,
                severity: "success",
                message: data.data.message,
              });
            } else if (data.data.status == 500) {
              setsnackBar2({
                ...snackBar2,
                open: true,
                severity: "warning",
                message: data.data.data,
              });
              // console.log(data.data.data);
            } else {
              setsnackBar({
                ...snackBar,
                open: true,
                severity: "warning",
                message: data.data.message,
              });
            }
          }
          setLoading(false);
        } catch (err) {
          setsnackBar({
            ...snackBar,
            open: true,
            severity: "error",
            message: err.message,
          });
          setLoading(false);
        }
    }
  });
    }else{
 
      setLoading(true);
      try {
        data = await axios({
          method: "post",
          url: IPaddress + "/income_estimate_form/store",
          data: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (data) {
          if (data.data.status == 200) {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "success",
              message: data.data.message,
            });
          } else if (data.data.status == 500) {
            setsnackBar2({
              ...snackBar2,
              open: true,
              severity: "warning",
              message: data.data.data,
            });
            // console.log(data.data.data);
          } else {
            setsnackBar({
              ...snackBar,
              open: true,
              severity: "warning",
              message: data.data.message,
            });
          }
        }
        setLoading(false);
      } catch (err) {
        setsnackBar({
          ...snackBar,
          open: true,
          severity: "error",
          message: err.message,
        });
        setLoading(false);
      }
  }
  };
  // ====================end store data============================

  //============format date to format yyyy-mm-dd============
  const formatDate = (date) => {
    let y = date.getFullYear();

    let m = date.getMonth() + 1;
    if (m < 10) m = "0" + m;

    let d = date.getDate();
    if (d < 10) d = "0" + d;

    return y + "-" + m + "-" + d;
  };

  //============end format date==============================

  // ====================Resources============================
  //get resource name...
  const setResourceForIncomeResource = (data, resource) => {
    let arrYTMp = [];
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // resource: resource,
            // other_resource_value: data.other_resource_value,
            // amount: data.amount,
            // comments: data.comments,
            ...data,
            resource: resource,
          };
          arrYTMp.push(custm);
          // if (resource == "نتيجة الحاسبة (تصاريح وحاسبة)") {
          //  getSelectedAmountForIncomeResource(custm);
          // } else if (resource == "نتيجة اللجنة الفاحصة") {
          //   getSelectedAmountForIncomeResource_classess(custm);
          // } 
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFIncomeResourceValue(arrYTMp);
    }
  };
  //get other resource name...
  const setOtherResourceForIncomeResource = (data, other_resource) => {
    let arrYTMp = [];
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // resource: data.resource,
            // other_resource_value: other_resource,
            // amount: data.amount,
            // comments: data.comments,
            ...data,
            other_resource_value: other_resource,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFIncomeResourceValue(arrYTMp);
    }
  };
  //get amount ...
  const setAmountForIncomeResource = (data, amount) => {
    let arrYTMp = [];
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // resource: data.resource,
            // other_resource_value: data.other_resource_value,

            // comments: data.comments,
            ...data,
            amount: amount ? amount : 0,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFIncomeResourceValue(arrYTMp);
    }
  };
  //get comments ...
  const setCommentsForIncomeResource = (data, comment) => {
    let arrYTMp = [];
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // resource: data.resource,
            // other_resource_value: data.other_resource_value,
            // amount: data.amount,
            // comments: comment,
            ...data,
            comments: comment,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFIncomeResourceValue(arrYTMp);
    }
  };

  //get summation of all resources  for any update...
  const summationOfAllResourcesFunction_update = () => {
    let sum = 0;
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        // if (data.index != dataItem.index) {
        if (!isNaN(dataItem.amount)) sum += parseInt(dataItem.amount);
        // }
      });
    }
    setSummationOfAllResources(sum);
    // return sum;
  };

  //get summation of all resources...
  const summationOfAllResourcesFunction = (data, value) => {
    let sum = parseInt(value);
    if (listOFIncomeResourceValue.length > 0) {
      listOFIncomeResourceValue.map((dataItem) => {
        if (data.index != dataItem.index) {
          if (!isNaN(dataItem.amount)) sum += parseInt(dataItem.amount);
        }
      });
    }
    setSummationOfAllResources(sum);
    // return sum;
  };
  //===========================================================

  // ====================discountreason============================
  //get reason name...
  const setDiscountReasonIDAndName = (data, reason) => {
    let arrYTMp = [];
    if (listOFDiscountValuesArrOBJ.length > 0) {
      listOFDiscountValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: reason,
            // other_reason_value: data.other_reason_value,
            // amount: data.amount,
            ...data,
            reason: reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFDiscountValuesArrOBJ(arrYTMp);
    }
  };
  //get other reason name...
  const setDiscountReasonOtherReason = (data, other_reason) => {
    let arrYTMp = [];
    if (listOFDiscountValuesArrOBJ.length > 0) {
      listOFDiscountValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: other_reason,
            // amount: data.amount,
            ...data,
            other_reason_value: other_reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFDiscountValuesArrOBJ(arrYTMp);
    }
  };
  //get amount ...
  const setDiscountReasonAmount = (data, amount) => {
    let arrYTMp = [];
    if (listOFDiscountValuesArrOBJ.length > 0) {
      listOFDiscountValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: data.other_reason_value,
            // amount: amount,
            ...data,
            amount: amount,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFDiscountValuesArrOBJ(arrYTMp);
    }
  };
  //===========================================================

  // ====================fines============================
  //get fines reason name...
  const setFinesIDAndName = (data, reason) => {
    let arrYTMp = [];
    if (listOFFinesValuesArrOBJ.length > 0) {
      listOFFinesValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: reason,
            // other_reason_value: data.other_reason_value,
            // amount: data.amount,
            ...data,
            reason: reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFFinesValuesArrOBJ(arrYTMp);
    }
  };
  //get other fines reason name...
  const setFinesOtherReason = (data, other_reason) => {
    let arrYTMp = [];
    if (listOFFinesValuesArrOBJ.length > 0) {
      listOFFinesValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: other_reason,
            // amount: data.amount,
            ...data,
            other_reason_value: other_reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFFinesValuesArrOBJ(arrYTMp);
    }
  };
  //get amount of fines...
  const setFinesAmount = (data, amount) => {
    let arrYTMp = [];
    if (listOFFinesValuesArrOBJ.length > 0) {
      listOFFinesValuesArrOBJ.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: data.other_reason_value,
            // amount: amount,
            ...data,
            amount: amount,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFFinesValuesArrOBJ(arrYTMp);
    }
  };
  //===========================================================

  // ====================interest============================
  //get Interests reason name...
  const setInterestsIDAndName = (data, reason) => {
    let arrYTMp = [];
    if (listOFInterestedValuesArrOBj.length > 0) {
      listOFInterestedValuesArrOBj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: reason,
            // other_reason_value: data.other_reason_value,
            // amount: data.amount,
            ...data,
            reason: reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFInterestedValuesArrOBj(arrYTMp);
    }
  };
  //get other Interests reason name...
  const setInterestsOtherReason = (data, other_reason) => {
    let arrYTMp = [];
    if (listOFInterestedValuesArrOBj.length > 0) {
      listOFInterestedValuesArrOBj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: other_reason,
            // amount: data.amount,
            ...data,
            other_reason_value: other_reason,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFInterestedValuesArrOBj(arrYTMp);
    }
  };
  //get amount of Interests...
  const setInterestAmount = (data, amount) => {
    let arrYTMp = [];
    if (listOFInterestedValuesArrOBj.length > 0) {
      listOFInterestedValuesArrOBj.map((dataItem) => {
        if (data.index == dataItem.index) {
          let custm = {
            // index: data.index,
            // reason: data.reason,
            // other_reason_value: data.other_reason_value,
            // amount: amount,
            ...data,
            amount: amount,
          };
          arrYTMp.push(custm);
        } else {
          arrYTMp.push(dataItem);
        }
      });
      setListOFInterestedValuesArrOBj(arrYTMp);
    }
  };
  //===========================================================


  const rederComponentsToSHow=()=>{
      if(props?.section_id==11){
         return <SourceOfIncome 
                  userRole={userRole}
                  setListOFIncomeResourceValue={setListOFIncomeResourceValue}
                  listOFIncomeResourceValue={listOFIncomeResourceValue}
                  setResourceForIncomeResource={setResourceForIncomeResource}
                  incomeResourceValuesArrOBJ={incomeResourceValuesArrOBJ}
                  setOtherResourceForIncomeResource={setOtherResourceForIncomeResource}
                  disableIncome={disableIncome}
                  selecetedAmount={selecetedAmount}
                  setAmountForIncomeResource={setAmountForIncomeResource}
                  summationOfAllResourcesFunction={summationOfAllResourcesFunction}
                  setsnackBar={setsnackBar}
                  snackBar={snackBar}
                  setCommentsForIncomeResource={setCommentsForIncomeResource}
                />
      }
      if(props?.section_id==12){
        return <SummationOfIncomeResources 
                 summationOfAllResources={summationOfAllResources}
               />
      } 
      if(props?.section_id==13){
        return <Discounts 
                 userRole={userRole}
                 setListOFDiscountValuesArrOBJ={setListOFDiscountValuesArrOBJ}
                 listOFDiscountValuesArrOBJ={listOFDiscountValuesArrOBJ}
                 setDiscountReasonIDAndName={setDiscountReasonIDAndName}
                 discountValuesArrOBJ={discountValuesArrOBJ}
                 setDiscountReasonOtherReason={setDiscountReasonOtherReason}
                 setDiscountReasonAmount={setDiscountReasonAmount}
               />
      } 
      if(props?.section_id==14){
        return <Permitted 
                 userRole={userRole}
                 FinalCalculation={FinalCalculation}
               />
      } 
      if(props?.section_id==15){
        return <TaxableIncome 
                 userRole={userRole}
                 taxableIncome={taxableIncome}
                 setTaxableIncom={setTaxableIncom}
                 taxableAmount={taxableAmount}
                 setTaxableAmount={setTaxableAmount}  
               />
      } 
      if(props?.section_id==16){
        return <Fines 
                 userRole={userRole}
                 setListOFFinesValuesArrOBJ={setListOFFinesValuesArrOBJ}
                 listOFFinesValuesArrOBJ={listOFFinesValuesArrOBJ}
                 setFinesIDAndName={setFinesIDAndName}
                 finesValuesArrOBj={finesValuesArrOBj}
                 setFinesOtherReason={setFinesOtherReason}
                 setFinesAmount={setFinesAmount}
               />
      }
      if(props?.section_id==17){
        return <Interest 
                 userRole={userRole}
                 setListOFInterestedValuesArrOBj={setListOFInterestedValuesArrOBj}
                 listOFInterestedValuesArrOBj={listOFInterestedValuesArrOBj}
                 setInterestsIDAndName={setInterestsIDAndName}
                 interestedValuesArrOBj={interestedValuesArrOBj}
                 setInterestsOtherReason={setInterestsOtherReason}
                 setInterestAmount={setInterestAmount}
               />
      }
      if(props?.section_id==18){
        return <PaymentsInfo 
                 userRole={userRole}
                 disableIncome={disableIncome}
                 voucherNumber={voucherNumber}
                 setVoucherNumber={setVoucherNumber}
                 voucherDate={voucherDate}
                 setVoucherDate={setVoucherDate}
                 finalTotalAmount={finalTotalAmount}
                 setOwnerDesision={setOwnerDesision}
                 ownerDecision={ownerDecision}
                 ownerDecisionDate={ownerDecisionDate}
                 setOwnerDecisionDate={setOwnerDecisionDate}
               />
      }
      if(props?.section_id==19){
        return <CommentOfEstimators 
                 userRole={userRole}
                 setTaxAssessor={setTaxAssessor}
                 userName={userName}
                 taxAssessorComments={taxAssessorComments}
                 setTaxAssessorComments={setTaxAssessorComments}
                 
               />
      }
      if(props?.section_id==20){
        return <CommentsOfChecker 
                 userRole={userRole}
                 setCheckerName={setCheckerName}
                 userName={userName}
                 checkerNameComments={checkerNameComments}
                 setCheckerNameComments={setCheckerNameComments}
               />
      }
      if(props?.section_id==21){
        return <CommentOfBranchManger 
                 userRole={userRole}
                 setBranchManager={setBranchManager}
                 userName={userName}
                 branchManagerComments={branchManagerComments}
                 setBranchManagerComments={setBranchManagerComments}
               />
      }

  };

  return (
  
    <div
      style={{
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      {
         rederComponentsToSHow()
      }


      

   

   
      
      <div
        style={{
          display: "flex",
          marginTop: 10,
          backgroundColor: "#fefefe",
          paddingLeft: 10,
          paddingRight: 10,
          paddingBottom: 30,

          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        {/* <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: userRole != 3 ? "15%" : "10%",
            fontSize: "20px",
          }}
          onClick={getCalculationsForAmount}
        >
          {!loading1 ? (
            userRole == 3 ? (
              "حساب"
            ) : (
              "اعادة حساب"
            )
          ) : (
            <div className="spinner-border " role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </Button> */}

        <Button
          variant="contained"
          style={{
            backgroundColor: "#5f7b8a",
            width: "40%",
            fontSize: "20px",
          }}
          onClick={()=>{
            if(ModeOfInsertData_tow=="حساب")
            getCalculationsForAmount(2)
            else 
            storeDataOfForm()
          }
          }
        >
          {!loading ? (
            ModeOfInsertData_tow=="حساب"?"حساب":ModeOfInsertData
          ) : (
            <div className="spinner-border " role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
        </Button>
      </div>

      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => {
          setsnackBar({ ...snackBar, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar.vertical,
          horizontal: snackBar.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar({ ...snackBar, open: false });
          }}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>

      {/* snack alert box here ... */}
      <Snackbar
        sx={{ height: "100%" }}
        open={snackBar2.open}
        // autoHideDuration={6000}
        onClose={() => {
          setsnackBar2({ ...snackBar2, open: false });
        }}
        anchorOrigin={{
          vertical: snackBar2.vertical,
          horizontal: snackBar2.horizontal,
        }}
      >
        <Alert
          onClose={() => {
            setsnackBar2({ ...snackBar2, open: false });
          }}
          severity={snackBar2.severity}
          sx={{ width: "100%" }}
        >
          {snackBar2.message?.length > 0
            ? snackBar2.message.map((mes) => <p>{mes}</p>)
            : ""}
        </Alert>
      </Snackbar>
    </div>
  );
}
